export default "/50f517735fec46580f19aae3e56e9fe21614ea75/0c7f90dcab4574f291a5b93f31621815.svg";